"use strict";

module.exports = {
  'cp': {
    'canSellFlag': 'CarParkBookings',
    'productClass': 'cp',
    'product': 'cp',
    'text': 'Airport Parking',
    'trackingValue': 'carpark'
  },
  'ho': {
    'canSellFlag': 'HotelBookings',
    'productClass': 'ho',
    'product': 'ho',
    'text': 'Airport Hotels',
    'trackingValue': 'hotel'
  },
  'hcp': {
    'canSellFlag': 'HotelParking',
    'productClass': 'hcp',
    'product': 'hcp',
    'text': "<span class='locationTag'>Airport </span>Hotel & Parking",
    'trackingValue': 'hotel_with_parking'
  },
  'meetandgreet': {
    'canSellFlag': 'CarParkBookings',
    'productClass': 'meetandgreet',
    'product': 'meetandgreet',
    'text': 'Meet & Greet',
    'link': '/airport-parking-meet-and-greet.html'
  },
  'lo': {
    'canSellFlag': 'LoungeBookings',
    'productClass': 'lo',
    'product': 'lo',
    'text': 'Airport Lounges',
    'link': '/airport-lounges.html',
    'trackingValue': 'lounge'
  },
  'ins': {
    'canSellFlag': 'InsuranceBookings',
    'productClass': 'ins',
    'product': 'ins',
    'text': 'Travel Insurance',
    'link': '/travel-insurance.html',
    'trackingValue': 'insurance'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/config/productOptions.js
// module id = 480
// module chunks = 119